<script setup lang="ts">
const props = defineProps({
  modelType: {
    type: String,
    required: true,
  },
  modelId: {
    type: String,
    required: true,
  },
  commentIdFromUrl: {
    type: String,
    default: '',
  },
})

const commentId = ref<string | null>()

const { sortComment, loadComments }
= useCommentBase(props.modelType, props.modelId)

const comments = loadComments()
const sortedCommentList = computed(() => sortComment(comments.value))

function setRespondId(id: string) {
  commentId.value = id
}
</script>

<template>
  <section class="pb-24">
    <div class="py-6 px-2">
      <span class="font-semibold">留言</span>
    </div>
    <div v-if="sortedCommentList.length === 0" class="flex flex-col justify-center items-center gap-4">
      <i i-ph-chats class="text-5xl" style="color: #737373;" />
      <p class="text-neutral-700">
        分享你對於故事的想法
      </p>
    </div>
    <common-comment-post
      v-for="c in sortedCommentList"
      :key="c.id"
      :is-highlighted="commentId === c.id"
      :model-type="modelType"
      :model-id="modelId"
      :comment="c"
      :is-scroll-target="commentIdFromUrl === c.id"
      @toggle-input="setRespondId"
    />
    <common-comment-input
      :model-type="modelType"
      :model-id="modelId"
      :comment-id="commentId"
      @clear-reply="commentId = null"
    />
  </section>
</template>
